export class IEmailFields {
   to: string = '';
   subject: string = '';
   body: string = '';

   constructor() {
      this.to = '';
      this.subject = '';
      this.body = '';
   }
}
